<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewAnalytics.orders.title') }}
      <v-card elevation="0">
        <v-row class="px-3">
          <v-col cols="4" md="3">
            <date-picker
                outlined
                :date-label="$t('viewAnalytics.start_date')"
                :date.sync="dateInterval.start"
                @change="changeInterval"
            />
          </v-col>
          <v-col cols="4" md="3">
            <date-picker
                outlined
                :date-label="$t('viewAnalytics.end_date')"
                :date.sync="dateInterval.end"
                @change="changeInterval"
            />
          </v-col>
          <v-col cols="4" md="3">
            <order-statuses-select
                :label="$t('common.status')"
                :items="order_statuses"
                :t-prefix="'common.orderSystemStatusNames.'"
                @update="(data)=>setStatuses(data)"
            ></order-statuses-select>
          </v-col>
        </v-row>
        <v-row  class="">
          <v-col cols="12">

            <v-progress-circular
                v-if="loadingInProcess.orders_statuses_statistics || !statusesIsFetched"
                size="64"
                indeterminate
                color="primary"
                class="mx-auto d-block"
            ></v-progress-circular>
            <GChart
                v-if="statusesIsFetched && ordersStatData && !loadingInProcess.orders_statuses_statistics && ordersStatData[0] && ordersStatData[0].length>1"
                class="mt-4"
                :settings="{ packages: ['corechart'] }"
                :data="ordersStatData"
                :options="ordersStatChartOptions"
                type="LineChart"
                @ready="onChartReady"
            />
            <template v-if="(statusesIsFetched && orders_statuses_statistics && orders_statuses_statistics.length===0 && !loadingInProcess.orders_statuses_statistics)">
              <v-alert
                  type="warning"
              >
                {{ $t('viewAnalytics.orders.orders_statuses_statistics') }}. {{$t('viewAnalytics.No_data_for_Selected_time_period')}}
              </v-alert>
            </template>
          </v-col>
        </v-row>
      </v-card>
    </h3>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';
import {mapFields} from 'vuex-map-fields';
import DatePicker from "@/components/common/DatePicker";
import CommonMixin from "@/mixins/common";
import OrderStatusesSelect from "@/components/order/OrderStatusesSelect.vue";

export default {
  name: "Orders",
  components: {OrderStatusesSelect, DatePicker, GChart},
  mixins: [CommonMixin],
  data:() => ({
    dateFormat: "DD.MM.YYYY",
    chartsLib: null,
    dateInterval:{
      start: null,
      end: null
    },
    selectedStatuses:[],
    disabledOrderStatuses: [],
    selectedStartDate: null,
    commonChartOptions: {
      legend: { position: 'bottom' },
      hAxis: {
        format: 'integer',
        minValue:0,
      },
      vAxis: {
        minValue:0,
        maxValue:2,
        format: '#'
      },
      height: 400,
      width:"100%",
      chartArea: {
        width: '100%',
        left:40
      },
      pointSize: 10,
      pointsVisible: true,
      //curveType: 'function',
    }
  }),
  created() {
    let monthBefore = new Date();
    monthBefore.setMonth(monthBefore.getMonth() - 1);

    let dd = String(monthBefore.getDate()).padStart(2, '0');
    let mm = String(monthBefore.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = monthBefore.getFullYear();
    this.dateInterval.start = yyyy+'-'+mm + '-' + dd;

    let today = new Date();
     dd = String(today.getDate()).padStart(2, '0');
     mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
     yyyy = today.getFullYear();
    this.dateInterval.end = yyyy+'-'+mm + '-' + dd;
    this.$store.dispatch('statuses/statusesGet').then(()=>{
      this.selectedStatuses = this.order_statuses;
          this.$nextTick(() => {
            this.changeInterval();
          })
    })
  },
  computed: {
    ...mapFields('statuses', ['order_statuses']),
    ...mapFields("statuses", { statusesIsFetched: "fetched" }),
    startDateFormatted() {
      return this.$moment(this.dateInterval.start).format(this.dateFormat)
    },
    endDateFormatted() {
      return this.$moment(this.dateInterval.end).format(this.dateFormat)
    },
    ...mapFields('analytics', [
      'created_orders',
      'orders_statuses_statistics',
      'loadingInProcess'
    ]),
    ordersStatChartOptions () {
      if (!this.chartsLib) return null;

      let colors = [];
      this.order_statuses.filter((status)=>
          !this.isStatusDisabled(status)
      ).forEach((status)=>{
        colors.push(status.color)
      })
      let cfg = {
        title: `${this.$t('viewAnalytics.orders.orders_statuses_statistics')} [${this.$t('viewAnalytics.from')} ${this.startDateFormatted} ${this.$t('viewAnalytics.to')} ${this.endDateFormatted}]`,
        colors: colors,
      }
      return {...this.commonChartOptions, ...cfg};
    },
    ordersStatData(){
      let res = [];
      if(this.orders_statuses_statistics && this.orders_statuses_statistics.length){
        let header = []
        header.push(this.$t('viewAnalytics.date'))
        this.order_statuses.filter((item)=> {
              return !this.isStatusDisabled(item)
            }
        ).forEach((status)=>{

            let statusName = status.system
                ? this.$t("common.orderSystemStatusNames." + status.name)
                : status.name
            header.push(statusName)
        })
        res.push(header);
        let dates = [];
        this.orders_statuses_statistics.forEach((item)=>{
          if(!dates.includes(item.date)){
            dates.push(item.date);
          }
        })
        dates.forEach(date=>{
          let day = [];
          let formattedDate = this.$moment(date).format(this.dateFormat)
          day.push(formattedDate);
          this.order_statuses.filter((status)=>
              !this.isStatusDisabled(status)
          ).forEach((status)=>{
            let value = 0
            this.orders_statuses_statistics.filter((status)=> {
                  return !this.isStatusDisabled({id:status.status_id, type:status.status_type})
                }
            ).forEach((item)=>{
              if(status.type===item.status_type && status.id === item.status_id && date===item.date){
                value = item.cnt;
              }
            })
            day.push(value)
          })
          res.push(day)
        })
        return res;
      }
      return null;
    }
  },
  methods: {
    setStatuses(data){
      this.selectedStatuses = data;
    },
    isStatusDisabled(needleStatus){
      let isFound = this.selectedStatuses.find((status)=>{
        return status.id===needleStatus.id && status.type === needleStatus.type
      })
      return !isFound
    },
    onChartReady (chart, google) {
      this.chartsLib = google
    },
    changeInterval(){
      this.$store.dispatch('analytics/get', {
        type: 'orders_statuses_statistics',
        start_date: this.dateInterval.start,
        end_date: this.dateInterval.end,
      })
    }
  }
}
</script>

<style scoped>

</style>